import { forwardRef } from 'react';
import { Flex } from './Flex';
import type { FlexProps } from './Flex.types';

const VFlex = forwardRef<HTMLDivElement, FlexProps>(({ ...props }, ref) => {
  return <Flex ref={ref} width="100%" direction="column" {...props} />;
});

VFlex.displayName = 'VFlex';

export { VFlex };
